export var DomSelectorUtils;
(function (DomSelectorUtils) {
    function getHtmlList(jsName, context = null, innerSearch = false) {
        if (!context) {
            context = document;
        }
        const nameParts = jsName.split(' ');
        let query = '';
        if (nameParts.length > 1) {
            nameParts.forEach((namePart, index) => {
                if (index > 0) {
                    query += ' ';
                }
                query += namePart;
            });
        }
        else {
            query = nameParts[0];
        }
        return getElementsByClassName(context, query, innerSearch);
    }
    DomSelectorUtils.getHtmlList = getHtmlList;
    function getInnerHtmlList(name, context) {
        return this.getHtmlList(name, context, true);
    }
    DomSelectorUtils.getInnerHtmlList = getInnerHtmlList;
    function getElementsByClassName(elem, className, innerSearch) {
        let list = [];
        function search(parent) {
            const children = parent.children;
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                if (child.classList) {
                    if (child.classList.contains('js_' + className)) {
                        list.push(children[i]);
                    }
                    if (!innerSearch || !/js_[A-Z]/.test(child.className)) {
                        search(child);
                    }
                }
            }
        }
        search(elem);
        return list;
    }
    function getInnerHtml(name, context = null, optional = false) {
        return this.getHtml(name, context, optional, true);
    }
    DomSelectorUtils.getInnerHtml = getInnerHtml;
    function getHtml(name, context = null, optional = false, innerSearch = false) {
        if (!context) {
            context = document;
        }
        const elems = this.getHtmlList(name, context, innerSearch);
        if (!optional && (!elems || elems.length === 0)) {
            console.error('element "js_' + name + '" not found inside given context. context:', context);
            console.dir(context);
            return null;
        }
        else if (elems.length > 1) {
            console.warn('element "js_' + name + '" found multiple times in given parent context. Will return first element found. context:', context);
            console.dir(context);
        }
        return elems[0];
    }
    DomSelectorUtils.getHtml = getHtml;
})(DomSelectorUtils || (DomSelectorUtils = {}));
